// extracted by mini-css-extract-plugin
export default {"popover":"popover_popover__e78lC","primary":"popover_primary__nwrxS","secondary":"popover_secondary__fHhM5"};